import { useQuery } from '@tanstack/react-query';
import { GamesData } from '../types/games';

const fetchGamesData = async (): Promise<GamesData> => {
  const response = await fetch('/data/games/index.json');
  if (!response.ok) {
    throw new Error('The game catalog could not be loaded.');
  }
  return response.json();
};

export const useGamesData = () => useQuery({
  queryKey: ['games'],
  queryFn: fetchGamesData,
  staleTime: Infinity,
  retry: 2,
});
